import { render } from "./ListOfInstances.vue?vue&type=template&id=f1cda9b8&scoped=true&ts=true"
import script from "./ListOfInstances.ts?vue&type=script&lang=ts"
export * from "./ListOfInstances.ts?vue&type=script&lang=ts"

import "./ListOfInstances.vue?vue&type=style&index=0&id=f1cda9b8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1cda9b8"]])

export default __exports__